import { Fragment } from 'react';
import ServicesSummary from './ServicesSummary';
import './loggedOut.css';

const Landing = () => {
    return (
        <div className="logged-out">
            <Fragment>
                <section className="landing-hero hero-full">
                    <div className="hero-full__bg" style={{ backgroundImage: "url('/marketing_images/home/main_homepage_image.png')" }}>
                        <div className="hero-full__overlay" />
                        <div className="container hero-full__content">
                            <div className="hero-full__copy">
                                <h1 style={{ fontSize: "3rem", fontWeight: 600 }}>
                                    Supporting <em>Independence</em>,<br />
                                    Empowering <em>Lives</em>
                                </h1>

                                <p className="lead mt-3">
                                    Providing personalised support through<br />
                                    South Australia
                                </p>

                                <div className="mt-4">
                                    <a
                                        href="/ContactUs"
                                        className="btn btn-success me-3"
                                        style={{
                                            borderRadius: "999px",
                                            padding: "0.6rem 1.6rem",
                                        }}
                                    >
                                        Contact Now -&gt;
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="landing-intro scene scene--paper" style={{paddingBottom: '5rem'}}>
                    <div className="container">
                        <div className="intro-card">
                            <p className="lead mx-auto" style={{ maxWidth: "850px" }}>
                                Beyond Community Access is a South Australian disability support agency, focused on highly individualised support. With amazing programs, and even better staff - BCA prides itself on evidence based, high quality supports, with measurable positive outcomes for its clientele.
                                An amazing and diverse team of disability support workers ensure that we have someone for everyone. Client - support worker matchup is extremely important for providing highly customised supports.
                            </p>

                            <div className="mt-4">
                                <a href="/OurServices" className="btn btn-primary mx-2">
                                    Our Services
                                </a>
                                <a href="/AboutUs" className="btn btn-outline-primary mx-2">
                                    About Us
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="landing-values scene scene--mist pb-5">
                    <div className="container">
                        <div className="section-head">
                            <h3 className="mb-3">Why Choose BCA?</h3>
                        </div>
                        <div className="value-grid">
                            {whyUs.map((val) => (
                                <div className="tile-card" key={val.title}>
                                    <div className="image-shell image-shell--card">
                                        <img
                                            src={val.icon}
                                            alt={val.title}
                                            className="img-fluid"
                                        />
                                    </div>
                                    <h5 className="mt-3">{val.title}</h5>
                                    <p className="mt-3 mb-0">{val.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <ServicesSummary />

                <section className="landing-testimonials scene scene--soft py-6">
                    <div className="container">
                        <div className="section-head">
                            <h3 className="mb-3">What Our Participants Say</h3>
                        </div>
                        <div className="testimonials-grid">
                            {testemonials.map((item, i) => (
                                <div className="testimonial-card" key={i}>
                                    <p className="mb-3 fst-italic">{item.quote}</p>
                                    <p className="fw-bold mb-0">{item.author}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </Fragment>
        </div>
    );

}

export default Landing;

const testemonials = [
    {
        quote: "BCA helped me find confidence in everything I do.",
        author: "Participant"
    },
    {
        quote: "The team feels like family.",
        author: "Family Member"
    }
];

const whyUs = [
    {
        title: "Highly Individualised Support",
        desc: "Tailored plans created collaboratively with clients, caregivers, allied health and support workers.",
        icon: "/marketing_images/home/highly_individualised_support.jpg"
    },
    {
        title: "Experienced & Caring Staff",
        desc: "Support workers with diverse strengths, matched to each participant's needs.",
        icon: "/marketing_images/home/experienced_and_caring_staff.jpg"
    },
    {
        title: "Measurable Outcomes",
        desc: "Support that focuses on progress, goals and positive change.",
        icon: "/marketing_images/home/measurable_outcomes.jpg"
    }
];
